/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Preview_StatusInputs */

const da_forside_preview_status = /** @type {(inputs: Forside_Preview_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-forslag · venter på din godkendelse`)
};

/** @type {(inputs: Forside_Preview_StatusInputs) => LocalizedString} */
const en_forside_preview_status = da_forside_preview_status;

/**

* @param {Forside_Preview_StatusInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_preview_status = /** @type {((inputs?: Forside_Preview_StatusInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Preview_StatusInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_preview_status(inputs)
	return /** @type {LocalizedString} */ ("AI-forslag · venter på din godkendelse")
});